import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonTextarea } from '@ionic/vue';
import { Color } from '@ionic/core';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormTextarea',
  props: {
    autoGrow: { type: Boolean },
    autocapitalize: null,
    autofocus: { type: Boolean },
    clearOnEdit: { type: Boolean },
    color: null,
    cols: null,
    debounce: null,
    disabled: { type: Boolean },
    enterkeyhint: null,
    fireFocusEvents: { type: Boolean },
    getInputElement: null,
    inputmode: null,
    maxlength: null,
    minlength: null,
    mode: null,
    name: null,
    placeholder: null,
    readonly: { type: Boolean },
    required: { type: Boolean },
    rows: null,
    setBlur: null,
    setFocus: null,
    spellcheck: { type: Boolean },
    value: null,
    wrap: null
  },
  setup(__props: any) {



const focused = ref<boolean>(false);

const focusClass = computed<Array<string>>(() => (focused.value ? ['border-b-primary'] : ['border-b-medium']));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonTextarea), {
    class: _normalizeClass(["rounded-lg border-b-[1px] border-solid border-transparent text-sm", [..._unref(focusClass)]]),
    "auto-grow": __props.autoGrow,
    cols: __props.cols,
    rows: __props.rows,
    wrap: __props.wrap,
    autocapitalize: __props.autocapitalize,
    clearOnEdit: __props.clearOnEdit,
    color: __props.color,
    debounce: __props.debounce,
    disabled: __props.disabled,
    enterkeyhint: __props.enterkeyhint,
    fireFocusEvents: __props.fireFocusEvents,
    getInputElement: __props.getInputElement,
    inputmode: __props.inputmode,
    maxlength: __props.maxlength,
    minlength: __props.minlength,
    mode: __props.mode,
    name: __props.name,
    placeholder: __props.placeholder,
    readonly: __props.readonly,
    required: __props.required,
    setBlur: __props.setBlur,
    setFocus: __props.setFocus,
    spellcheck: __props.spellcheck,
    value: __props.value,
    onFocusin: _cache[0] || (_cache[0] = ($event: any) => (focused.value = true)),
    onFocusout: _cache[1] || (_cache[1] = ($event: any) => (focused.value = false))
  }, null, 8, ["class", "auto-grow", "cols", "rows", "wrap", "autocapitalize", "clearOnEdit", "color", "debounce", "disabled", "enterkeyhint", "fireFocusEvents", "getInputElement", "inputmode", "maxlength", "minlength", "mode", "name", "placeholder", "readonly", "required", "setBlur", "setFocus", "spellcheck", "value"]))
}
}

})